// The tips the splash shows while the dashboard loads: one line each, 8 to 10 words, naming something a person can
// do in RowCall today (never a feature that isn't shipped; brand/TEXT-KIT.md → Coming). One is picked per page load.

export const LOADING_TIPS: readonly string[] = [
  'Press ⌘K to jump to any call, flow or contact.',
  'Connect your Shopify store and RowCall keeps orders in step.',
  'Test a flow in your browser before shoppers hear it.',
  'Press Take over to step into a live call yourself.',
  'One opt-out stops every flow from calling that shopper again.',
  'Export any flow’s results as CSV from the Results page.',
  'Set calling hours, and RowCall waits for the right moment.',
  'Retries call busy shoppers back later, as often as needed.',
  'Webhooks send every call’s outcome straight to your own systems.',
  'Invite your team and choose what each role may do.',
]

/** One tip at random (`random` is in [0, 1), like Math.random). */
export const pickTip = (random: number): string =>
  LOADING_TIPS[Math.floor(random * LOADING_TIPS.length)] ?? LOADING_TIPS[0] ?? ''

/** How many words a tip has (⌘K counts as one). */
export const wordCount = (tip: string): number => tip.split(/\s+/).filter(Boolean).length
